module.exports = __webpack_public_path__ + "static/media/banner@2x.29ee9e1e.png";